import React, { useEffect, useState } from 'react';
import {
  Button,
  IconButton,
  InputAdornment,
  Modal,
  TextField,
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { useSnackbar } from 'notistack';
import { copyTextToClipboard } from '../InviteMemberModal/invitationFormUtils';
import {
  FooterActions,
  StyledPaper,
  StyledTitle,
} from '../InviteMemberModal/styles';
import { InviteManuallyModalProps } from './types';

export function InviteManuallyModal({
  isOpen,
  magicLink,
  onClose,
}: InviteManuallyModalProps) {
  const { enqueueSnackbar } = useSnackbar();
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);

  useEffect(() => {
    setCopiedToClipboard(false);
  }, [magicLink]);

  const handleCopyInvitationLink = async () => {
    const copiedSuccessfully = await copyTextToClipboard(magicLink);
    setCopiedToClipboard(copiedSuccessfully);

    if (!copiedSuccessfully) {
      enqueueSnackbar('Failed to copy link to clipboard', { variant: 'error' });
    }
  };

  return (
    <Modal
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1301,
      }}
      open={isOpen}
      onClose={onClose}
      disableEnforceFocus
    >
      <StyledPaper elevation={0}>
        <StyledTitle variant="h6">Invite Manually</StyledTitle>
        <TextField
          variant="outlined"
          value={magicLink}
          fullWidth
          label="Magic link"
          InputLabelProps={{ shrink: true }}
          helperText="Use the link if the original Invitation failed. The link expires if clicked"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleCopyInvitationLink}
                  title="Copy to clipboard"
                  edge="end"
                >
                  {copiedToClipboard ? <CheckIcon /> : <FileCopyOutlinedIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <FooterActions>
          <Button onClick={onClose} color="primary" variant="text">
            Close
          </Button>
        </FooterActions>
      </StyledPaper>
    </Modal>
  );
}
